import React from 'react';
import { connect } from 'react-redux';
import { Drawer, Form, Button, Row, Col, Input, InputNumber, Select, Modal, Switch, Icon } from 'antd';
import moment from 'moment';
import { compare } from 'natural-orderby';
import uid from 'uid';
import get from 'lodash/get';

import InputCurrency, { currency2Float } from '../UI/InputCurrency';
import { pad } from '../UI/Utils';
import { DatePicker } from '../UI/DatePicker/Locale';
import NumericInput from '../UI/InputNumber';

import * as billsToReceiveActions from '~/components/BillsToReceive/actions';
import { PERMISSIONS } from '~/constants/permissions.constants';

const { Option } = Select;

var METHOD_LABELS = { 1: 'Dinheiro', 2: 'Boleto', 3: 'Cartão', 4: 'Transferência', 5: 'Pix', 6: 'Depósito', 7: 'Cheque' };

function getDueStatus(dueDate) {
    if (!dueDate) return null;
    var due = moment(dueDate, 'YYYY-MM-DD');
    var today = moment().startOf('day');
    var diff = due.diff(today, 'days');
    if (diff < 0) return { text: 'Vencida há ' + Math.abs(diff) + ' dia' + (Math.abs(diff) > 1 ? 's' : ''), color: '#f5222d' };
    if (diff === 0) return { text: 'Vence hoje', color: '#fa8c16' };
    if (diff <= 7) return { text: 'Vence em ' + diff + ' dia' + (diff > 1 ? 's' : ''), color: '#fa8c16' };
    if (diff <= 30) return { text: 'Vence em ' + diff + ' dias', color: '#fadb14' };
    return { text: 'Vence em ' + diff + ' dias', color: '#52c41a' };
}

class BillsForm extends React.Component {
    state = {
        payments: [],
        deleted: []
    }

    onCreate = () => {
        const { form } = this.props;
        const context = this;

        form.validateFields((err, values) => {

            if (err) {
                return;
            }

            let sum = 0;
            Object.keys(values.payments).map(function(key, index) {
              sum = sum+values.payments[key].amount;
            });

            if(Math.trunc(values.total) !== Math.trunc(sum)){
              form.setFields({
                total: {
                  value: values.total,
                  errors: [new Error('Total não corresponde com a soma das parcelas')],
                },
              });
            }else{

              this.props.registerBill({...values, dash_task_id: this.props.billForm.data.dash_task_id})
              .then(response => {
                  form.resetFields();
                  context.onClose();
                  if(context.props.filter.filter_by !== null){
                    context.props.loadExtras(context.props.filter);
                  }
              });

            }
        });

    }

    onSave = () => {
        const { form, filter } = this.props;
        const context = this;

        form.validateFields((err, values) => {

            if (err) {
                return;
            }

            this.props.saveBill(this.props.billForm.data.id, {...values, deleted: this.state.deleted})
            .then(response => {
                form.resetFields();
                context.onClose();
                context.props.loadExtras(filter);
            });
        });

    }

    componentWillReceiveProps = (nextProps) => {
      if(nextProps.billForm.data !== null && nextProps.billForm.data !== this.props.billForm.data){
        const { payments } = nextProps.billForm.data;
        if( payments !== null && payments !== undefined){
          let p = [];
          payments.map(payment => {
            p.push({...payment, uid: uid(10)});
          })
          this.setState({payments: p});
        }
      }
    }

    onDelete = () => Modal.confirm({
      title: 'Você realmente deseja excluir este serviço extra?',
      content: 'Todas as parcelas serão removidas. Esta ação não poderá ser desfeita.',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => this.props.deleteBill(this.props.billForm.data.id)
    });

    changePaymentSplit = (val) => {
      let p = [];
      for(let i=1; i <= val; i++){
        p.push({
          due_date: moment().add(i, 'months').format('YYYY-MM-DD'),
          amount: this.props.form.getFieldValue('total')/val,
          method: 1,
          uid: uid(10),
          cod: null,
          new: true
        });
      }
      //Verifica se possui ID, e adiciona no array para ser excluido
      var d = [];
      this.state.payments.map(function(payment){
        if(typeof payment.id !== 'undefined'){
          d.push(payment.id);
        }
      });
      this.setState({payments: p, deleted: [...this.state.deleted, ...d]});
    }

    onClose = () => {
      this.setState({payments: [], deleted: [], default: {}});
      this.props.onClose();
    }

    render() {
        const { payments } = this.state;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { customers, billForm, user } = this.props;

        const data = {
            ...this.state.default,
            ...billForm.data
        }

        const canEdit = (user.permissions.includes(PERMISSIONS.extraServices.edit) && data.id !== null) || data.id === null;
        const canDelete = user.permissions.includes(PERMISSIONS.extraServices.delete);

        const optionsPayment = () => {
            let o = [];
            for (let i = 1; i <= 12; i++) {
                o.push(<Option key={i} value={i}>{i}x</Option>);
            }
            return o;
        }

        const SOC = get(data, 'dash_task_id');

        // Summary calculations
        var totalValue = this.props.form.getFieldValue('total') || data.total || 0;
        var paidSum = 0;
        if (payments && payments.length > 0) {
          for (var pi = 0; pi < payments.length; pi++) {
            if (payments[pi].paid_at) paidSum += (payments[pi].amount || 0);
          }
        }
        var balanceValue = totalValue - paidSum;

        return (
        <div>
          {billForm.open && (
            <Drawer
                title={(data.id) ? (canEdit ? 'Editar Serviço Extra' : 'Serviço Extra') : 'Cadastrar Serviço Extra'}
                width={800}
                placement="right"
                onClose={this.onClose}
                maskClosable={false}
                visible={billForm.open}
                destroyOnClose={true}
                style={{
                    height: '100%',
                    overflow: 'auto',
                    paddingBottom: 53,
                }}
            >
           <Form layout="vertical">
                <Row gutter={16}>
                    <Col span={!SOC? 18 : 24}>
                        <Form.Item label="Empresa">
                            {getFieldDecorator('customer_id', {
                                initialValue: data.customer_id? data.customer_id:null,
                                rules: [{ required: true, message: 'Por favor selecione uma opção!' }],
                            })(
                                <Select
                                    showSearch
                                    placeholder="Selecione uma empresa"
                                    optionFilterProp="children"
                                    onChange={(val) => this.setState({default: {...this.state.default, customer_id: val}})}
                                    disabled={(data.customer_id? true: false)}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                {customers!==null && customers.map(row =>
                                    <Option value={row.id} key={row.id}>{`${row.cod} - ${row.name}`}</Option>
                                )}
                              </Select>
                            )}
                        </Form.Item>
                    </Col>
                    {!SOC && (
                    <Col span={6}>
                        <Form.Item label="Societário">
                        {getFieldDecorator('dash_task_id', {
                            initialValue: get(data, 'dash_task_id'),
                        })(<NumericInput addonBefore={"#SOC"} placeholder=""/>)}
                        </Form.Item>
                    </Col>
                    )}
                    <Col span={24}>
                        <Form.Item label="Nome da tarefa">
                        {getFieldDecorator('task_name', {
                            initialValue: data.task_name,
                            rules: [{ required: true, message: 'Por favor informe o nome da tarefa!' }],
                        })(<Input placeholder="Dê um nome a esta tarefa" disabled={!canEdit}/>)}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Apuração">
                        {getFieldDecorator('apuration_at', {
                            initialValue: data.id? moment(data.apuration_at, 'YYYY-MM-DD'): moment(),
                            rules: [{ required: true, message: 'Por favor escolha uma data!' }],
                        })(
                            <DatePicker disabled={!canEdit}/>
                        )}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Valor Total">
                        {getFieldDecorator('total', {
                            initialValue: data.total,
                            rules: [{ required: true, message: 'Por favor informe o valor total!' }],
                            normalize: (value) => currency2Float(value)
                        })(<InputCurrency disabled={!canEdit}/>)}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label={
                        <span>
                          Parcelamento
                          {payments.length > 0 && totalValue > 0 && (
                            <span style={{ fontWeight: 400, color: '#8c8c8c', marginLeft: 6 }}>
                              ({payments.length}x de R$ {(totalValue / payments.length).toFixed(2).replace('.', ',')})
                            </span>
                          )}
                        </span>
                      }>
                      {getFieldDecorator('payment_split', {
                          initialValue: payments.length === 0? null:payments.length,
                          rules: [{ required: true, message: 'Por favor selecione a quantidade de parcelas.' }],
                      })(<Select onChange={this.changePaymentSplit} disabled={!canEdit}>
                          {optionsPayment()}
                      </Select>)}
                      </Form.Item>
                  </Col>
                </Row>

                {/* Pagamento section */}
                <div style={{ marginTop: 8, marginBottom: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                    <Icon type="credit-card" style={{ color: '#8c8c8c' }} />
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#262626' }}>Pagamento</span>
                    {data.id && (
                      <span style={{
                        marginLeft: 'auto', fontSize: 12, color: '#8c8c8c',
                        display: 'flex', gap: 12
                      }}>
                        <span>Total: <strong style={{ color: '#262626' }}>R$ {totalValue.toFixed(2).replace('.', ',')}</strong></span>
                        <span>Pago: <strong style={{ color: '#52c41a' }}>R$ {paidSum.toFixed(2).replace('.', ',')}</strong></span>
                        <span>Saldo: <strong style={{ color: balanceValue > 0 ? '#f5222d' : '#52c41a' }}>R$ {balanceValue.toFixed(2).replace('.', ',')}</strong></span>
                      </span>
                    )}
                  </div>

                  {payments && payments.map((row, index) => {
                    var isPaid = row.paid_at !== null && row.paid_at !== undefined;
                    var borderColor = isPaid ? '#b7eb8f' : '#e8e8e8';
                    var bgColor = isPaid ? '#f6ffed' : '#fff';
                    var dueStatus = !isPaid ? getDueStatus(row.due_date) : null;

                    return (
                      <div
                        key={row.uid}
                        style={{
                          border: '1px solid ' + borderColor,
                          borderLeft: '3px solid ' + (isPaid ? '#52c41a' : '#d9d9d9'),
                          borderRadius: 6,
                          padding: '12px 16px',
                          marginBottom: 8,
                          background: bgColor,
                          transition: 'all 0.2s',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', gap: 4,
                              fontSize: 12, fontWeight: 600, color: isPaid ? '#52c41a' : '#f5222d',
                              padding: '2px 8px', borderRadius: 10,
                              background: isPaid ? '#f6ffed' : '#fff1f0',
                              border: '1px solid ' + (isPaid ? '#b7eb8f' : '#ffa39e'),
                              cursor: 'default'
                            }}>
                              <Icon type={isPaid ? 'check-circle' : 'clock-circle'} style={{ fontSize: 11 }} />
                              {isPaid ? 'Pago' : 'Pendente'}
                            </span>
                            {row.id && (
                              <span style={{ fontSize: 11, color: '#bfbfbf', fontFamily: 'monospace' }}>
                                SE{pad(row.id, 4)}
                              </span>
                            )}
                            <span style={{ fontSize: 13, fontWeight: 500, color: '#262626' }}>
                              Parcela {index + 1}
                            </span>
                          </div>
                          {dueStatus && (
                            <span style={{ fontSize: 11, color: dueStatus.color, fontWeight: 500 }}>
                              {dueStatus.text}
                            </span>
                          )}
                        </div>
                        <Row gutter={12}>
                          <Col span={6}>
                            <Form.Item label="Vencimento" style={{ marginBottom: 0 }}>
                              {getFieldDecorator(`payments[${row.uid}][due_date]`, {
                                initialValue: moment(row.due_date, 'YYYY-MM-DD'),
                                rules: [{ required: true, message: 'Informe a data!' }],
                              })(<DatePicker
                                onChange={
                                  (e) => this.setState({
                                    payments: [...payments.map((item) => {
                                      if(item.id !== row.id){
                                        return item;
                                      }else{
                                        return {
                                          ...item,
                                          value: e? e.format('YYYY-MM-DD'):null
                                        }
                                      }
                                    })]
                                })}
                                disabled={!canEdit}
                                style={{ width: '100%' }}
                              />)}
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Valor" style={{ marginBottom: 0 }}>
                              {getFieldDecorator(`payments[${row.uid}][amount]`, {
                                initialValue: row.amount,
                                rules: [{ required: true, message: 'Informe o valor!' }],
                                normalize: (value) => currency2Float(value)
                              })(
                                <InputCurrency disabled={!canEdit}/>
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Forma PGTO" style={{ marginBottom: 0 }}>
                              {getFieldDecorator(`payments[${row.uid}][method]`, {
                                initialValue: row.method,
                                rules: [{ required: true, message: 'Selecione!' }],
                              })(
                                <Select disabled={!canEdit}>
                                  <Option key={1} value={1}>Dinheiro</Option>
                                  <Option key={2} value={2}>Boleto</Option>
                                  <Option key={3} value={3}>Cartão</Option>
                                  <Option key={4} value={4}>Transferência</Option>
                                  <Option key={5} value={5}>Pix</Option>
                                  <Option key={6} value={6}>Depósito</Option>
                                  <Option key={7} value={7}>Cheque</Option>
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Cód" style={{ marginBottom: 0 }}>
                              {getFieldDecorator(`payments[${row.uid}][cod]`, {
                                initialValue: row.cod,
                              })(
                                <Input disabled={!canEdit} placeholder="Opcional"/>
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Form.Item style={{ display: 'none' }}>
                          {getFieldDecorator(`payments[${row.uid}][id]`, {
                            initialValue: data.id ? row.id : null,
                          })(
                            <Input disabled={!canEdit}/>
                          )}
                        </Form.Item>
                      </div>
                    );
                  })}
                </div>
                {get(data, 'id') && user.permissions.includes(PERMISSIONS.extraServices.edit) && (function() {
                  var isRevised = getFieldValue('revised') !== undefined ? getFieldValue('revised') : data.revised;
                  return (
                    <div style={{
                      marginTop: 20,
                      padding: '16px 20px',
                      borderRadius: 10,
                      border: '1.5px solid ' + (isRevised ? '#b7eb8f' : '#e8e8e8'),
                      background: isRevised ? '#f6ffed' : '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 16,
                      transition: 'all 0.2s',
                    }}>
                      <div style={{
                        width: 40, height: 40, borderRadius: 8,
                        background: isRevised ? '#52c41a18' : '#f5f5f5',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                      }}>
                        <Icon type="audit" style={{ fontSize: 20, color: isRevised ? '#52c41a' : '#8c8c8c' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 14, color: '#262626', marginBottom: 2 }}>Revisão financeira</div>
                        <div style={{ fontSize: 13, color: '#8c8c8c' }}>Marque como revisado após conferir os valores e parcelas deste serviço extra.</div>
                      </div>
                      {getFieldDecorator('revised', { valuePropName: 'checked', initialValue: !!data.revised })(
                        <Switch />
                      )}
                    </div>
                  );
                })()}
            </Form>
            <div
                style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e8e8e8',
                padding: '10px 16px',
                textAlign: 'right',
                left: 0,
                background: '#fff',
                borderRadius: '0 0 4px 4px',
                }}
            >
              {data.id && canEdit && canDelete && (<Button onClick={this.onDelete} type="danger" style={{marginRight: '8px'}}><Icon type="delete" /> Deletar</Button>)}
              <Button
              style={{
                  marginRight: 8,
              }}
              onClick={this.onClose}
              >
              Cancelar
              </Button>
              {(data.id && user.permissions.includes(PERMISSIONS.extraServices.edit)) && (
              <Button onClick={this.onSave} type="primary"><Icon type="save" /> Salvar</Button>
              )}
              {data.id === undefined && (
              <Button onClick={this.onCreate} type="primary"><Icon type="plus" /> Cadastrar</Button>
              )}
            </div>
            </Drawer>
          )}
        </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        customers: state.customers.list.filter(row => row.enabled === 1 && row.inactived_at === null && row.is_customer).sort((a,b) => compare()(a.cod, b.cod)),
        billForm: state.customerExtras.form,
        filter: state.customerExtras.filter
    }
}

const mapDispatchProps = dispatch => {
    return{
      registerBill: (data) => dispatch({
        type: 'REGISTER_BILL',
        payload: {
          request:{
            method: 'post',
            url:'/extras',
            data: data
          }
        }
      }),
      saveBill: (id, data) => dispatch({
        type: 'SAVE_BILL',
        payload: {
          request:{
            method: 'post',
            url:`/extras/${id}`,
            data: data
          }
        }
      }),
      loadExtras: (filter) => dispatch(billsToReceiveActions.loadExtras(filter)),
      deleteBill: (id) => dispatch({
        type: 'DELETE_BILL',
        payload: {
          request:{
            method: 'delete',
            url:'/extras/'+id,
          }
        },
        id: id
      }),
      onClose: () => dispatch({
        type: 'CLOSE_BILL_FORM',
        payload: null
      }),
    }
  }

export default connect(mapStateToProps, mapDispatchProps)(Form.create()(BillsForm));
